import type { Scenario } from '../types';

export const noInternetScenario: Scenario = {
  id: 'no-internet',
  name: 'No Internet (APIPA)',
  initialState: {
    isFixed: false,
    ipReleased: false,
    actionLog: [],
    openWindows: [],
    activeWindow: null,
  },
  desktopIcons: [
    {
      id: 'ico-network',
      label: 'Network Settings',
      emoji: '📶',
      opensApp: 'network-settings',
    },
    {
      id: 'ico-pc',
      label: 'This PC',
      emoji: '🖥️',
      opensApp: 'this-pc',
    },
    {
      id: 'ico-bin',
      label: 'Recycle Bin',
      emoji: '🗑️',
      opensApp: 'recycle-bin',
    },
    {
      id: 'ico-cmd',
      label: 'Command Prompt',
      emoji: '⬛',
      opensApp: 'command-prompt',
    },
  ],
  availableApps: [
    'network-settings',
    'command-prompt',
    'this-pc',
    'recycle-bin',
  ],
};
